export default __webpack_public_path__ + "static/media/ic_download_primary.d56f3f6c.svg";